import axios from 'axios'
import { openNewTabBlobFile } from '../helper'

export const getFinanceJoinedPurchaseInvoice = (id) => {
  return axios.get(`/finance/joinedPurchaseInvoices/${id}`)
}

export const addFinanceJoinedPurchaseInvoice = (data) => {
  return axios.post(`/finance/joinedPurchaseInvoices`, data)
}

export const editFinanceJoinedPurchaseInvoice = (data) => {
  return axios.put(`/finance/joinedPurchaseInvoices/${data.id}`, data)
}

export const deleteFinanceJoinedPurchaseInvoice = (id) => {
  return axios.delete(`/finance/joinedPurchaseInvoices/${id}`)
}

export const deleteOnAddJoinFinancePurchaseInvoiceAttachment = (url) => {
  return axios.delete('/finance/joinedPurchaseInvoices/attachments', { data: { url } })
}

export const deleteOnEditFinanceJoinPurchaseInvoiceAttachment = (id, url) => {
  return axios.delete(`/finance/joinedPurchaseInvoices/${id}/attachments`, { data: { url } })
}

export const createPdfJoinedPurchaseInvoice = (id) => {
  return axios
    .get(`/finance/joinedPurchaseInvoices/${id}/print`, { responseType: 'blob' })
    .then((response) => {
      openNewTabBlobFile(response.data)
      return Promise.resolve(true)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}

export const getJoinPurchaseInvoiceSmsTemplate = (id) => {
  return axios.get(`/finance/joinedPurchaseInvoices/${id}/sms`)
}

export const sendJoinPurchaseInvoiceSms = (id, data) => {
  return axios.post(`/finance/joinedPurchaseInvoices/${id}/sms`, data)
}

export const getJoinPurchaseInvoiceEmailTemplate = (id) => {
  return axios.get(`/finance/joinedPurchaseInvoices/${id}/email`)
}

export const sendPurchaseJoinInvoiceEmail = (id, data) => {
  return axios.post(`/finance/joinedPurchaseInvoices/${id}/email`, data)
}

export const getJoinPurchaseInvoiceWaTemplate = (id) => {
  return axios.get(`/finance/joinedPurchaseInvoices/${id}/whatsapp`)
}

export const getJoinPurchaseInvoiceInputWhatsappTemplate = (id) => {
  return axios.get(`/finance/joinedPurchaseInvoices/${id}/inputWhatsapp`)
}

export const sendJoinPurchaseInvoiceWhatsapp = (payload) => {
  const { id, ...body } = payload
  return axios.post(`/finance/joinedPurchaseInvoices/${id}/whatsapp`, body)
}

export const inputMassSendEmailJoinPurchaseInvoice = (data) => {
  return axios.post('/finance/joinedPurchaseInvoices/inputMassEmail', data)
}

export const executeMassSendEmailJoinPurchaseInvoice = (data) => {
  return axios.post('/finance/joinedPurchaseInvoices/executeMassEmail', data)
}

export const inputMassSendWhatsappJoinPurchaseInvoice = (data) => {
  return axios.post('/finance/joinedPurchaseInvoices/inputMassWhatsapp', data)
}

export const executeMassSendWhatsappJoinPurchaseInvoice = (data) => {
  return axios.post('/finance/joinedPurchaseInvoices/executeMassWhatsapp', data)
}

export const getJoinedPurchaseInvoiceLog = ({ id, params } = {}) => {
  return axios.get(`/finance/joinedPurchaseInvoices/${id}/logs`, { params })
}
